import { useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { TOption, StorageService, StorageKey } from '@treezor/design-system';

import { ILookupField } from '@/ui-kit/table-filters/filters.type';
import { ICardTransactionFilterFormFields } from '@/store/types/card-transactions.type';
import { IMccData, useMccRef } from '@/hooks/useMccRef';

export function mapCardTransactionMcc(value: string) {
  return {
    mcc: value,
  };
}

export function useCardTransactionMccField(
  methods: UseFormReturn<ICardTransactionFilterFormFields>,
  onChange,
): ILookupField {
  const currentLang = StorageService.get(StorageKey.LANGUAGE);

  const mccList = useMccRef();

  const handleMccChange = useCallback(
    (value: ICardTransactionFilterFormFields['mcc']) => {
      methods.setValue('mcc', value);
      onChange();
    },
    [onChange, methods],
  );

  const mccOptions: TOption[] = (mccList || [])?.map((mcc: IMccData) => ({
    label: mcc[currentLang === 'fr' ? 'DescriptionFR' : 'DescriptionEN'],
    value: mcc.MCC,
  }));

  const mccValue = mccOptions?.find((option) => methods.watch('mcc')?.includes(option.value as string))?.value;

  return {
    value: mccValue,
    handleChange: handleMccChange,
    options: mccOptions,
  };
}
